var $ = require('jQuery');
var MergeFields = require('../../lib/merge-fields.js');

module.exports = function() {

    $('#review-send').click(function(e) {
        e.preventDefault();

        var form = $(this).parents('form');
        var action = form.attr('action');

        form.attr('action', action + '/review');
        form.submit();
    });

    $('#discard').click(function(e) {
        e.preventDefault();

        var form = $(this).parents('form');
        var method = form.find('[name="_method"]');

        $(method).val('DELETE');

        form.submit();
    });

    $('.button-pill-close.submit').click(function() {
        var form = $(this).parents('form');
        form.submit();
    });

    $('#legalBasis').change(function () {
        var url = new URL(window.location.href);
        url.searchParams.set('legalBasis', $(this).val());
        var form = $(this).parents('form');
        $.pjax({url: url.href, data: form.serialize(), type: 'POST'});
    });

    // Merge fields
    var mergeFields = new MergeFields();
    mergeFields.setup('merge-fields', 'input[id="subject"],textarea[id="body"]');
};
